"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_FONT_FAMILIES = exports.EMAIL_SAFE_FONT_FAMILIES = exports.WAYPOINT_NATIVE_EMAIL_FONT_FAMILIES = exports.snapToClosestEmailFontSize = exports.isEmailTextFontSize = exports.EMAIL_TEXT_FONT_SIZES = exports.EMAIL_TEXT_LINE_HEIGHT = exports.EMAIL_HEADING_TYPOGRAPHY_MOBILE = exports.EMAIL_HEADING_TYPOGRAPHY = exports.BOLD_FONT_WEIGHT = exports.YOUTUBE_THUMBNAIL_QUALITY = exports.ZEFFY_FOOTER_LOGO_LIGHT = exports.ZEFFY_FOOTER_LOGO_DARK = exports.VIDEO_BLOCK_PLAY_ICON_URL = exports.SOCIAL_ICON_IMAGE_URLS_BLACK = exports.SOCIAL_ICON_IMAGE_URLS_WHITE = exports.SOCIAL_ICON_IMAGE_URLS_COLOURED = exports.SOCIAL_PLATFORMS = exports.isAnyReminder = exports.isReminderV1 = exports.isReminderV2 = exports.EMAIL_HTML_IMPORT_QUEUE_WAIT_BUDGET_MS = exports.EMAIL_HTML_IMPORT_POST_PROCESS_BUDGET_MS = exports.EMAIL_HTML_IMPORT_CONVERSION_DEADLINE_MS = exports.EMAIL_HTML_IMPORT_ATTEMPT_TIMEOUT_MS = exports.EMAIL_HTML_IMPORT_MAX_OUTPUT_TOKENS = exports.EMAIL_HTML_IMPORT_MAX_CHARS = exports.MAGIC_EMAIL_MAX_EXTRA_INFO_LENGTH = exports.MAGIC_EMAIL_EXTRA_INFO_SEPARATOR = exports.MAGIC_EMAIL_MAX_ADDITIONAL_DETAILS_TRIES = exports.MAGIC_EMAIL_MAX_PROMPT_LENGTH = exports.MAGIC_EMAIL_PROMPT_WARNING_LENGTH = exports.EVENT_REMINDER_MAX_OFFSET = exports.MAX_TEST_EMAIL_RECIPIENTS = exports.TEST_EMAIL_SUBJECT_PREFIX = exports.hasTrackedLinks = exports.EMAIL_DELIVERY_LINK_ID_KEY = exports.requiresCommunicationConsent = exports.resolveCommunicationType = exports.COMMUNICATION_TYPES = exports.AUTOMATED_EMAIL_TYPES = exports.DELETABLE_EMAIL_TYPES = exports.DYNAMIC_RECIPIENTS_EMAIL_TYPES = exports.EMAIL_PADDING_SLIDER_MAX = exports.DEFAULT_CONTAINER_PADDING = exports.DEFAULT_ROOT_PADDING = exports.WEEKLY_EMAILS_LIMIT = exports.DAILY_EMAILS_LIMIT = exports.MAX_RECIPIENTS_LIMIT_CUSTOM_DOMAIN = exports.CUSTOM_DOMAIN_RECIPIENT_THRESHOLD = void 0;
exports.EMAIL_CONTENT_BASELINE = exports.WAYPOINT_MIN_COLUMNS_COUNT = exports.WAYPOINT_MAX_COLUMNS_COUNT = exports.WAYPOINT_ROOT_BLOCK_ID = exports.EMAIL_CANVAS_MAX_WIDTH = exports.EMAIL_FORM_GOAL_PLACEHOLDER_CENTS = exports.EMAIL_FORM_VOLUME_PLACEHOLDER_CENTS = exports.EMAIL_PREVIEW_TEXT_MOBILE_VISIBLE_LENGTH = exports.EMAIL_PREVIEW_TEXT_MAX_LENGTH = exports.EMAIL_WRAPPER_ID = exports.EMAIL_BUTTON_SIZES = exports.EMAIL_BUTTON_STYLES = void 0;
exports.resolveCrmEmailType = resolveCrmEmailType;
const common_1 = require("../enums/common");
const email_1 = require("../enums/email");
const ticketing_1 = require("../enums/ticketing");
exports.CUSTOM_DOMAIN_RECIPIENT_THRESHOLD = 5000;
// Custom domain reputation issues don't affect Zeffy's main domain
exports.MAX_RECIPIENTS_LIMIT_CUSTOM_DOMAIN = 30_000;
exports.DAILY_EMAILS_LIMIT = 50000;
exports.WEEKLY_EMAILS_LIMIT = 150000;
/**
 * Default padding for email builder root blocks and containers.
 * Used by both frontend (EmailBuilder) and server (Unlayer to Waypoint converter).
 */
exports.DEFAULT_ROOT_PADDING = {
    top: 8,
    bottom: 8,
    left: 24,
    right: 24,
};
exports.DEFAULT_CONTAINER_PADDING = {
    top: 8,
    bottom: 8,
    left: 8,
    right: 8,
};
exports.EMAIL_PADDING_SLIDER_MAX = 40;
exports.DYNAMIC_RECIPIENTS_EMAIL_TYPES = [
    common_1.EmailContentType.FOLLOW_UP,
    common_1.EmailContentType.BLAST,
    common_1.EmailContentType.POST_EVENT,
    common_1.EmailContentType.REMINDER,
    common_1.EmailContentType.REMINDER2,
];
exports.DELETABLE_EMAIL_TYPES = [common_1.EmailContentType.FOLLOW_UP, common_1.EmailContentType.BLAST];
exports.AUTOMATED_EMAIL_TYPES = [
    common_1.EmailContentType.REMINDER,
    common_1.EmailContentType.REMINDER2,
    common_1.EmailContentType.POST_EVENT,
    common_1.EmailContentType.THANK_YOU,
    common_1.EmailContentType.AUCTION_WINNERS,
    common_1.EmailContentType.AUCTION_NON_WINNERS,
    common_1.EmailContentType.OUTBID,
    common_1.EmailContentType.ORDER_SHIPPED,
    common_1.EmailContentType.READY_FOR_PICKUP,
    common_1.EmailContentType.MEMBERSHIP_EXPIRATION,
    common_1.EmailContentType.MEMBERSHIP_AUTO_RENEWAL,
];
exports.COMMUNICATION_TYPES = ["designed", "simple", "automated"];
const resolveCommunicationType = ({ emailType, flow, }) => {
    if ((emailType && exports.AUTOMATED_EMAIL_TYPES.includes(emailType)) || flow === common_1.EmailContentFlow.FormEditor) {
        return "automated";
    }
    return flow === common_1.EmailContentFlow.Quick ? "simple" : "designed";
};
exports.resolveCommunicationType = resolveCommunicationType;
const CONSENT_EXEMPT_DESIGNED_TYPES = [
    // A blast's audience already paid; an extra thank-you answers a payment.
    common_1.EmailContentType.BLAST,
    common_1.EmailContentType.EXTRA_THANK_YOU_EMAIL,
];
// Designed sends are marketing unless listed above; automated and Quick-flow sends are exempt.
const requiresCommunicationConsent = (emailContent) => (0, exports.resolveCommunicationType)(emailContent) === "designed" &&
    !(emailContent.emailType && CONSENT_EXEMPT_DESIGNED_TYPES.includes(emailContent.emailType));
exports.requiresCommunicationConsent = requiresCommunicationConsent;
// Workflows nurture newsletter sign-ups; invitations and their follow-ups target people who have not bought yet.
const NEWSLETTER_EMAIL_TYPES = [
    common_1.EmailContentType.CRMWORKFLOW,
    common_1.EmailContentType.INVITATION,
    common_1.EmailContentType.FOLLOW_UP,
];
const CAMPAIGN_EMAIL_TYPES = [
    common_1.EmailContentType.REMINDER,
    common_1.EmailContentType.REMINDER2,
    common_1.EmailContentType.POST_EVENT,
    common_1.EmailContentType.BLAST,
];
function resolveCrmEmailType({ emailType, recipientCount, }) {
    if (emailType && NEWSLETTER_EMAIL_TYPES.includes(emailType)) {
        return email_1.CrmEmailType.Newsletter;
    }
    if (emailType && CAMPAIGN_EMAIL_TYPES.includes(emailType)) {
        return email_1.CrmEmailType.Campaign;
    }
    if (recipientCount === null) {
        return null;
    }
    if (recipientCount === 1) {
        return email_1.CrmEmailType.OneToOne;
    }
    return email_1.CrmEmailType.Newsletter;
}
exports.EMAIL_DELIVERY_LINK_ID_KEY = "zlinkid";
const TRACKED_LINK_PATTERN = new RegExp(`[?&](?:amp;)?${exports.EMAIL_DELIVERY_LINK_ID_KEY}=[0-9a-f-]{36}(?![0-9a-f-])`, "i");
const hasTrackedLinks = (body) => TRACKED_LINK_PATTERN.test(body ?? "");
exports.hasTrackedLinks = hasTrackedLinks;
exports.TEST_EMAIL_SUBJECT_PREFIX = "(Test) ";
exports.MAX_TEST_EMAIL_RECIPIENTS = 10;
exports.EVENT_REMINDER_MAX_OFFSET = 365;
/** Soft cap: show the "keep it short" warning once a Magic Email prompt exceeds this. */
exports.MAGIC_EMAIL_PROMPT_WARNING_LENGTH = 300;
/** Hard cap: disable submit and reject on the backend once a Magic Email prompt exceeds this. */
exports.MAGIC_EMAIL_MAX_PROMPT_LENGTH = 1000;
exports.MAGIC_EMAIL_MAX_ADDITIONAL_DETAILS_TRIES = 1;
exports.MAGIC_EMAIL_EXTRA_INFO_SEPARATOR = ", ";
// final prompt + the one extra-details pass
const MAGIC_EMAIL_EXTRA_INFO_ENTRY_COUNT = exports.MAGIC_EMAIL_MAX_ADDITIONAL_DETAILS_TRIES + 1;
exports.MAGIC_EMAIL_MAX_EXTRA_INFO_LENGTH = MAGIC_EMAIL_EXTRA_INFO_ENTRY_COUNT * exports.MAGIC_EMAIL_MAX_PROMPT_LENGTH +
    (MAGIC_EMAIL_EXTRA_INFO_ENTRY_COUNT - 1) * exports.MAGIC_EMAIL_EXTRA_INFO_SEPARATOR.length;
exports.EMAIL_HTML_IMPORT_MAX_CHARS = 300_000;
exports.EMAIL_HTML_IMPORT_MAX_OUTPUT_TOKENS = 16_000;
exports.EMAIL_HTML_IMPORT_ATTEMPT_TIMEOUT_MS = 165_000;
exports.EMAIL_HTML_IMPORT_CONVERSION_DEADLINE_MS = 200_000;
exports.EMAIL_HTML_IMPORT_POST_PROCESS_BUDGET_MS = 45_000;
exports.EMAIL_HTML_IMPORT_QUEUE_WAIT_BUDGET_MS = 60_000;
const isReminderV2 = ({ flow, emailType, formCategory, }) => {
    return ((flow === common_1.EmailContentFlow.FormEditor || flow === common_1.EmailContentFlow.Quick) &&
        (emailType === common_1.EmailContentType.REMINDER || emailType === common_1.EmailContentType.REMINDER2) &&
        formCategory === ticketing_1.TicketingFormCategory.Event);
};
exports.isReminderV2 = isReminderV2;
const isReminderV1 = ({ flow, emailType }) => {
    return flow === common_1.EmailContentFlow.Builder && emailType === common_1.EmailContentType.REMINDER;
};
exports.isReminderV1 = isReminderV1;
const isAnyReminder = (emailType) => {
    return emailType === common_1.EmailContentType.REMINDER || emailType === common_1.EmailContentType.REMINDER2;
};
exports.isAnyReminder = isAnyReminder;
exports.SOCIAL_PLATFORMS = {
    Facebook: { label: "Facebook", url: "https://facebook.com/" },
    Instagram: { label: "Instagram", url: "https://instagram.com/" },
    X: { label: "X (Twitter)", url: "https://x.com/" },
    YouTube: { label: "YouTube", url: "https://youtube.com/" },
    LinkedIn: { label: "LinkedIn", url: "https://linkedin.com/" },
    TikTok: { label: "TikTok", url: "https://tiktok.com/" },
    Email: { label: "Email", url: "mailto:" },
    Website: { label: "Website", url: "https://" },
    Zeffy: { label: "Zeffy", url: "" },
};
/**
 * Cloudinary URLs for coloured social icons (40×40 PNG).
 * Used when iconColor is "Coloured" in the email builder socials block.
 */
exports.SOCIAL_ICON_IMAGE_URLS_COLOURED = {
    Facebook: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710122/features/email-builder/facebook.png",
    Instagram: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710123/features/email-builder/instagram.png",
    LinkedIn: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710122/features/email-builder/linkedin.png",
    X: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710122/features/email-builder/x.png",
    TikTok: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710122/features/email-builder/tiktok.png",
    YouTube: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710122/features/email-builder/youtube.png",
    Email: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_png,w_120,q_auto/v1775661467/features/email-builder/email.svg",
    Website: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_png,w_120,q_auto/v1775727546/features/email-builder/website.svg",
    Zeffy: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_png,w_120,q_auto/v1775727549/features/email-builder/zeffy.svg",
};
exports.SOCIAL_ICON_IMAGE_URLS_WHITE = {
    Facebook: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710122/features/email-builder/facebook-white.png",
    Instagram: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710123/features/email-builder/instagram-white.png",
    LinkedIn: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710122/features/email-builder/linkedin-white.png",
    X: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710122/features/email-builder/x-white.png",
    TikTok: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710122/features/email-builder/tiktok-white.png",
    YouTube: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710122/features/email-builder/youtube-white.png",
    Email: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_png,w_120,q_auto/v1775661468/features/email-builder/email-white.svg",
    Website: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_png,w_120,q_auto/v1775727547/features/email-builder/website-white.svg",
    Zeffy: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_png,w_120,q_auto/v1775727550/features/email-builder/zeffy-white.svg",
};
exports.SOCIAL_ICON_IMAGE_URLS_BLACK = {
    Facebook: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710122/features/email-builder/facebook-black.png",
    Instagram: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710123/features/email-builder/instagram-black.png",
    LinkedIn: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710122/features/email-builder/linkedin-black.png",
    X: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710122/features/email-builder/x-black.png",
    TikTok: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710122/features/email-builder/tiktok-black.png",
    YouTube: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1769710122/features/email-builder/youtube-black.png",
    Email: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_png,w_120,q_auto/v1775661468/features/email-builder/email-black.svg",
    Website: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_png,w_120,q_auto/v1775727548/features/email-builder/website-black.svg",
    Zeffy: "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_png,w_120,q_auto/v1775727552/features/email-builder/zeffy-black.svg",
};
exports.VIDEO_BLOCK_PLAY_ICON_URL = "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_auto,q_auto/v1770371500/VideoBlockPreview_zzealh.png";
exports.ZEFFY_FOOTER_LOGO_DARK = "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_png,w_480,q_auto/v1775661844/features/email-builder/zeffy-logo-dark.svg";
exports.ZEFFY_FOOTER_LOGO_LIGHT = "https://res.cloudinary.com/hxn9dbuhd/image/upload/f_png,w_480,q_auto/v1775661845/features/email-builder/zeffy-logo-light.svg";
exports.YOUTUBE_THUMBNAIL_QUALITY = "hqdefault";
// 700 is the only bold weight email-safe fonts reliably ship; 500/600 silently degrade to regular.
exports.BOLD_FONT_WEIGHT = 700;
exports.EMAIL_HEADING_TYPOGRAPHY = {
    h1: {
        fontWeight: 500,
        fontSize: "40px",
        lineHeight: "1.2",
        letterSpacing: "-0.25px",
    },
    h2: {
        fontWeight: 500,
        fontSize: "28px",
        lineHeight: "1.25",
        letterSpacing: "0",
    },
    h3: {
        fontWeight: 500,
        fontSize: "22px",
        lineHeight: "1.3",
        letterSpacing: "0.25px",
    },
    h4: {
        fontWeight: 500,
        fontSize: "18px",
        lineHeight: "1.35",
        letterSpacing: "0",
    },
};
/**
 * Mobile heading typography overrides for responsive emails.
 * Applied via @media query; `!important` is needed to override juice-inlined desktop styles.
 * Supported by Apple Mail, iOS Mail, Android clients. Gmail falls back to desktop sizes.
 */
exports.EMAIL_HEADING_TYPOGRAPHY_MOBILE = {
    h1: { fontSize: "34px", lineHeight: "1.2" },
    h2: { fontSize: "24px", lineHeight: "1.25" },
    h3: { fontSize: "20px", lineHeight: "1.3" },
    h4: { fontSize: "16px", lineHeight: "1.35" },
};
exports.EMAIL_TEXT_LINE_HEIGHT = 1.5;
exports.EMAIL_TEXT_FONT_SIZES = [10, 12, 14, 16, 18, 20, 22, 24];
const isEmailTextFontSize = (value) => exports.EMAIL_TEXT_FONT_SIZES.includes(value);
exports.isEmailTextFontSize = isEmailTextFontSize;
const snapToClosestEmailFontSize = (fontSize) => exports.EMAIL_TEXT_FONT_SIZES.reduce((closest, candidate) => Math.abs(candidate - fontSize) < Math.abs(closest - fontSize) ? candidate : closest);
exports.snapToClosestEmailFontSize = snapToClosestEmailFontSize;
exports.WAYPOINT_NATIVE_EMAIL_FONT_FAMILIES = [
    "MODERN_SANS",
    "BOOK_SANS",
    "ORGANIC_SANS",
    "GEOMETRIC_SANS",
    "HEAVY_SANS",
    "ROUNDED_SANS",
    "MODERN_SERIF",
    "BOOK_SERIF",
    "MONOSPACE",
];
exports.EMAIL_SAFE_FONT_FAMILIES = [
    "ARIAL",
    "CENTURY_GOTHIC",
    "COURIER_NEW",
    "GEORGIA",
    "IMPACT",
    "PALATINO",
    "TAHOMA",
    "TIMES_NEW_ROMAN",
    "TREBUCHET_MS",
    "VERDANA",
];
exports.EMAIL_FONT_FAMILIES = [...exports.WAYPOINT_NATIVE_EMAIL_FONT_FAMILIES, ...exports.EMAIL_SAFE_FONT_FAMILIES];
exports.EMAIL_BUTTON_STYLES = ["rectangle", "rounded", "pill"];
exports.EMAIL_BUTTON_SIZES = ["x-small", "small", "medium", "large"];
exports.EMAIL_WRAPPER_ID = "email-content-wrapper";
exports.EMAIL_PREVIEW_TEXT_MAX_LENGTH = 150;
exports.EMAIL_PREVIEW_TEXT_MOBILE_VISIBLE_LENGTH = 55;
exports.EMAIL_FORM_VOLUME_PLACEHOLDER_CENTS = 100_000;
exports.EMAIL_FORM_GOAL_PLACEHOLDER_CENTS = 500_000;
exports.EMAIL_CANVAS_MAX_WIDTH = 600;
exports.WAYPOINT_ROOT_BLOCK_ID = "root";
exports.WAYPOINT_MAX_COLUMNS_COUNT = 3;
exports.WAYPOINT_MIN_COLUMNS_COUNT = 2;
exports.EMAIL_CONTENT_BASELINE = {
    fontFamily: "Arial, helvetica, sans-serif",
    fontSize: 16,
    fontWeight: 400,
    letterSpacing: "0.15008px",
    lineHeight: 1.5,
    paragraphMargin: 0,
};
